import { EditorState } from '../../slices/editor';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../index';

export const selectTemplateInstanceFormatValues = (): any =>
    createSelector(
        (state: RootState) => state.editor,
        (state: EditorState) => state.instanceTemplate?.formatValues || [],
    );
